import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setIsAppReloadRequired } from '../actions/appActions';

const useAppReload = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const handleAppReloadRequired = (event) => {
      const { appVersion, forceReload, isAppReloadRequired } = event.detail;
      if(isAppReloadRequired) {
        dispatch(setIsAppReloadRequired(isAppReloadRequired));
      }
    };

    window.addEventListener('appReloadRequired', handleAppReloadRequired);

    return () => {
      window.removeEventListener('appReloadRequired', handleAppReloadRequired);
    };
  }, [dispatch]);
};

export default useAppReload; 